import DomainEntity from '@/models/DomainEntity'

export default class StateResults extends DomainEntity {
  static get collectionName() {
    return 'stateresults/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      financial: {},
      studies: {},
      comments: {
        clients: [],
        staff: [],
        stats: {
          clients: {
            amount: 0,
            grade: 0,
          },
          staff: {
            amount: 0,
            good: 0,
            bad: 0,
          },
        },
      },
      infos: StateResults.defaultInfos(),
    }
  }

  /**
   * Bloc `infos` par défaut. `initialCapital` et `initialTreasury` proviennent des
   * paramètres généraux de l'application lors de la création d'un nouvel état.
   */
  static defaultInfos(initialCapital = 0, initialTreasury = 0) {
    return {
      initialCapital: initialCapital,
      socialCapital: initialCapital,
      netSituation: initialCapital,
      immo: 0,
      initialTreasury: initialTreasury,
      treasury: initialTreasury,
      treasuryVariation: initialTreasury - initialCapital,
      ca: 0,
      caVariation: 0,
      result: 0,
      resultVariation: 0,
      taxes: 0,
      taxesVariation: 0,
      dept: 0,
      deptVariation: 0,
      contractHours: 0,
      prodStaffHours: 0,
    }
  }
}
